import AlertPopup from 'components/common/PortalModal/popups/AlertPopup';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';

const CancelFxAddTransactionModal = ({
  isShow,
  title,
  content,
  action,
  actionClose,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    // Deferred by one microtask so this modal's close lands in a separate
    // React commit from actionClose's store update (e.g. the calculator-modal
    // reopen callback wired in FxFormAddTransaction/Order's
    // handleOnClickCloseButton). Closing this modal in the same commit as
    // that remount can land a new Transition-backed mount and this modal's
    // Fade-wrapped unmount in the same commit, racing react-bootstrap's
    // Transition and crashing (browser-smoke#148, mirrors #147's fix).
    queueMicrotask(() => closePortalModalName());
  };

  return (
    <AlertPopup
      isOpen={isShow}
      text={title || ''}
      content={content || ''}
      buttonLabel1={t('button_no')}
      onClose={handleOnClose}
      buttonLabel2={t('button_yes')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default CancelFxAddTransactionModal;
